import { render, staticRenderFns } from "./SelectChannel.vue?vue&type=template&id=7fc48186&scoped=true&"
import script from "./SelectChannel.vue?vue&type=script&lang=js&"
export * from "./SelectChannel.vue?vue&type=script&lang=js&"
import style0 from "./SelectChannel.vue?vue&type=style&index=0&id=7fc48186&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc48186",
  null
  
)

export default component.exports